/* ═══════════════════════════════════════════════════════════════════════
   TIGHA — Startseite in Bewegung (11.10.2026, v5 abends)
   v5: keine festgehaltenen Scroll-Strecken mehr. Daniel und Shearling sind
   Wähler (chooser): Klicken, Überfahren (Daniel), Tastatur, Wischen; ohne
   Eingriff wechseln sie langsam selbst, bis jemand wählt. Dazu: Love Story
   wechselt das Bild Herren/Damen, Journal zeigt beim Überfahren das Bild,
   das Manifest hellt beim Scrollen Wort für Wort auf, Einblendungen kürzer
   und früher. Läuft neben home.js und setzt nur Klassen und CSS-Variablen.
   Ohne html.h5m (kein JS, "Bewegung reduzieren", Animationen aus) bleibt
   alles im Endzustand; die Wähler funktionieren dann ohne Übergang.
   ═══════════════════════════════════════════════════════════════════════ */
(function () {
  'use strict';
  if (window.tighaMotion) return;

  var html = document.documentElement;
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)');
  var fine = window.matchMedia('(hover: hover) and (pointer: fine)');
  var items = [];
  var ticking = false;
  var hasIO = 'IntersectionObserver' in window;

  function motionOn() {
    return !reduce.matches && !!document.body && document.body.classList.contains('anim-on');
  }
  function clamp(v, a, b) { return v < a ? a : v > b ? b : v; }
  function range(v, a, b) { return clamp((v - a) / (b - a), 0, 1); }
  function easeOut(t) { return 1 - Math.pow(1 - t, 3); }
  function put(el, cache, name, v) {
    var s = v.toFixed(4);
    if (cache[name] !== s) { cache[name] = s; el.style.setProperty(name, s); }
  }
  function each(list, fn) { Array.prototype.forEach.call(list, fn); }
  function once(el, key) {
    if (el.dataset[key]) return false;
    el.dataset[key] = '1';
    return true;
  }
  /* Bild mit data-h5-src/-srcset (bzw. eigenem Präfix) jetzt laden */
  function loadImg(im, pre) {
    pre = pre || 'data-h5-';
    var src = im.getAttribute(pre + 'src');
    if (!src) return;
    var ss = im.getAttribute(pre + 'srcset');
    if (ss) im.setAttribute('srcset', ss);
    im.setAttribute('src', src);
    im.removeAttribute(pre + 'src');
    im.removeAttribute(pre + 'srcset');
  }

  /* ── Eine Schleife für alles, was am Scrollen hängt ─────────────────── */
  function frame() {
    ticking = false;
    var vh = window.innerHeight;
    for (var i = 0; i < items.length; i++) {
      var it = items[i];
      if (!it.el.isConnected) continue;
      var r = it.el.getBoundingClientRect();
      if (r.bottom < -vh || r.top > vh * 2) continue;
      it.update(r, vh);
    }
  }
  function request() {
    if (ticking) return;
    ticking = true;
    window.requestAnimationFrame(frame);
  }

  /* ── Maus: weich nachgeführte Werte -1 … 1 ───────────────────────────── */
  function follow(area, target, nx, ny, k) {
    var tx = 0, ty = 0, x = 0, y = 0, raf = 0, cache = {};
    function loop() {
      x += (tx - x) * k;
      y += (ty - y) * k;
      put(target, cache, nx, x);
      put(target, cache, ny, y);
      raf = Math.abs(tx - x) > 0.001 || Math.abs(ty - y) > 0.001 ? window.requestAnimationFrame(loop) : 0;
    }
    function kick() { if (!raf) raf = window.requestAnimationFrame(loop); }
    area.addEventListener('pointermove', function (e) {
      if (e.pointerType && e.pointerType !== 'mouse') return;
      var b = area.getBoundingClientRect();
      tx = clamp(((e.clientX - b.left) / b.width) * 2 - 1, -1, 1);
      ty = clamp(((e.clientY - b.top) / b.height) * 2 - 1, -1, 1);
      kick();
    });
    area.addEventListener('pointerleave', function () { tx = 0; ty = 0; kick(); });
  }

  /* ── Einblendungen: kurz vor dem Bildrand starten (wirkt schneller) ─── */
  function revealEarly(scope) {
    if (!hasIO) return;
    var io = new IntersectionObserver(function (en) {
      en.forEach(function (e) {
        if (!e.isIntersecting) return;
        e.target.classList.add('in');
        io.unobserve(e.target);
      });
    }, { rootMargin: '0px 0px 8% 0px', threshold: 0 });
    each(scope.querySelectorAll('.h5 .rv:not(.in)'), function (el) { io.observe(el); });
  }

  /* ── Überschriften: Wörter einzeln maskiert ─────────────────────────── */
  function split(el) {
    if (!once(el, 'h5split')) return;
    var n = 0;
    (function walk(node) {
      each(Array.prototype.slice.call(node.childNodes), function (k) {
        if (k.nodeType === 3) {
          if (!k.textContent.trim()) return;
          var frag = document.createDocumentFragment();
          each(k.textContent.split(/(\s+)/), function (part) {
            if (!part) return;
            if (/^\s+$/.test(part)) { frag.appendChild(document.createTextNode(part)); return; }
            var w = document.createElement('span');
            var i = document.createElement('span');
            w.className = 'h5w';
            i.className = 'h5w__i';
            i.style.setProperty('--wi', n++);
            i.textContent = part;
            w.appendChild(i);
            frag.appendChild(w);
          });
          node.replaceChild(frag, k);
        } else if (k.nodeType === 1 && k.tagName !== 'BR' && !k.classList.contains('visually-hidden')) {
          walk(k);
        }
      });
    })(el);
    el.classList.add('h5split');
    if (el.classList.contains('in')) {
      /* home.js hat schon eingeblendet: einmal neu anstoßen, damit die Wörter fahren */
      el.classList.remove('in');
      void el.offsetWidth;
      window.requestAnimationFrame(function () {
        window.requestAnimationFrame(function () { el.classList.add('in'); });
      });
    }
  }

  /* ── Produktschienen (alt, ausgeblendet): Karten nacheinander ───────── */
  function rails(scope) {
    var list = scope.querySelectorAll('.h5 .slider');
    if (!list.length) return;
    var io = hasIO ? new IntersectionObserver(function (en) {
      en.forEach(function (e) {
        if (!e.isIntersecting) return;
        e.target.classList.add('h5in');
        io.unobserve(e.target);
      });
    }, { rootMargin: '0px 0px -10% 0px', threshold: 0.05 }) : null;
    each(list, function (sl) {
      if (!once(sl, 'h5rail')) return;
      each(sl.querySelectorAll('.pcard'), function (c, i) { c.style.setProperty('--ci', Math.min(i, 8)); });
      var b = sl.getBoundingClientRect();
      if (!io || b.top < window.innerHeight * 0.9) { sl.classList.add('h5in'); return; }
      io.observe(sl);
    });
  }

  /* ── Startbild ──────────────────────────────────────────────────────── */
  function hero(scope) {
    var h = scope.querySelector('.h5 .hero');
    if (!h || !once(h, 'h5hero')) return;
    var media = h.querySelector('.hero-media');
    if (!media) return;
    var cache = {};
    items.push({ el: h, update: function (r) {
      put(media, cache, '--hs', clamp(-r.top / Math.max(1, r.height), 0, 1));
    } });
    if (fine.matches) follow(h, media, '--hx', '--hy', 0.07);
  }

  /* ── Kopfzeile: beim Runterscrollen Platz machen, beim Hochscrollen sofort da ──
     Erst unterhalb des Startbilds. Bleibt stehen, solange die Maus darüber ist
     oder der Fokus darin liegt (Tastatur, offenes Menü). */
  function headerAway() {
    var h = document.querySelector('.hdr');
    if (!h || (window.Shopify && window.Shopify.designMode) || !once(h, 'h5away')) return;
    var lastY = window.pageYOffset || 0, acc = 0, away = false, raf = 0, over = false;
    function set(v) {
      if (v === away) return;
      away = v;
      h.classList.toggle('h5-away', v);
    }
    /* nur Tastatur-Fokus hält die Kopfzeile (Android fokussiert Knöpfe auch beim Antippen) */
    function keyFocus() {
      var a = document.activeElement;
      if (!a || a === document.body || !h.contains(a)) return false;
      try { return a.matches(':focus-visible'); } catch (err) { return true; }
    }
    function tick() {
      raf = 0;
      var max = Math.max(0, document.documentElement.scrollHeight - window.innerHeight);
      var y = clamp(window.pageYOffset || 0, 0, max);          /* iOS-Gummiband am Ende zählt nicht als Hochscrollen */
      var dy = y - lastY;
      lastY = y;
      var locked = document.body && document.body.style.overflow === 'hidden';   /* Menü/Warenkorb offen */
      if (y < Math.max(260, window.innerHeight * 0.75) || over || keyFocus()) { acc = 0; set(false); return; }
      /* festgehaltenes Regal füllt den Bildschirm: Kopfzeile bleibt weg, auch beim Hochscrollen */
      if (html.classList.contains('h5-pin-on')) {
        var ps = document.querySelector('.h5r.is-pin'), pr = ps && ps.getBoundingClientRect();
        if (pr && pr.top <= 1 && pr.bottom > window.innerHeight * 0.6) { acc = 0; set(true); return; }
        html.classList.remove('h5-pin-on');
      }
      if (dy === 0 || locked) return;
      if (Math.abs(dy) > window.innerHeight * 0.9) { acc = 0; return; }   /* Sprung (Anker, Wiederherstellen) */
      if ((dy > 0) !== (acc > 0)) acc = 0;
      acc += dy;
      if (acc > 28) set(true);
      else if (acc < -24) set(false);
    }
    window.addEventListener('scroll', function () { if (!raf) raf = window.requestAnimationFrame(tick); }, { passive: true });
    h.addEventListener('pointerenter', function (e) { if (e.pointerType === 'mouse') { over = true; set(false); } });
    h.addEventListener('pointerleave', function () { over = false; });
    h.addEventListener('focusin', function () { if (keyFocus()) set(false); });
    window.addEventListener('resize', function () { lastY = window.pageYOffset || 0; acc = 0; });
    /* oben am Fenster mit der Maus: Kopfzeile holen */
    if (fine.matches) {
      document.addEventListener('pointermove', function (e) { if (away && e.pointerType === 'mouse' && e.clientY < 12) set(false); }, { passive: true });
    }
  }

  /* ── Wähler: Reiter + Inhalte mit gleicher Nummer (data-ch-tab/-panel) ─ */
  function chooser(root, cfg) {
    cfg = cfg || {};
    var tabs = Array.prototype.slice.call(root.querySelectorAll('[data-ch-tab]'));
    var n = tabs.length;
    if (!n) return null;
    var cur = 0;
    tabs.forEach(function (t, k) { if (t.getAttribute('aria-selected') === 'true') cur = k; });
    var num = root.querySelector('[data-ch-num]');
    var stopAuto = function () {};

    function show(i, opt) {
      opt = opt || {};
      if (opt.user) { stopAuto(); if (cfg.onUser) cfg.onUser(); }
      i = ((i % n) + n) % n;
      if (i === cur) { if (opt.focus) tabs[i].focus(); return; }
      var prev = cur;
      cur = i;
      root.setAttribute('data-dir', (opt.dir || (i > prev ? 1 : -1)) > 0 ? 'next' : 'prev');
      tabs.forEach(function (t, k) {
        var on = k === i;
        t.setAttribute('aria-selected', on ? 'true' : 'false');
        t.tabIndex = on ? 0 : -1;
        t.classList.toggle('is-on', on);
      });
      each(root.querySelectorAll('[data-ch-panel]'), function (p) {
        var k = +p.getAttribute('data-ch-panel');
        var on = k === i;
        p.classList.toggle('is-on', on);
        p.classList.toggle('is-out', k === prev);
        p.classList.remove('is-anim');
        if (on) { void p.offsetWidth; p.classList.add('is-anim'); }
        if (p.hasAttribute('data-ch-hide')) p.hidden = !on;
        if (p.hasAttribute('data-ch-inert')) {
          if (on) { p.removeAttribute('inert'); p.removeAttribute('aria-hidden'); }
          else { p.setAttribute('inert', ''); p.setAttribute('aria-hidden', 'true'); }
        }
      });
      if (num) num.textContent = String(i + 1);
      if (cfg.onChange) cfg.onChange(i, prev);
      if (opt.focus) tabs[i].focus();
    }

    tabs.forEach(function (t, k) {
      t.addEventListener('click', function () { show(k, { user: true }); });
      t.addEventListener('keydown', function (e) {
        var key = e.key, to = null, dir = 1;
        if (key === 'ArrowRight' || key === 'ArrowDown') to = k + 1;
        else if (key === 'ArrowLeft' || key === 'ArrowUp') { to = k - 1; dir = -1; }
        else if (key === 'Home') { to = 0; dir = -1; }
        else if (key === 'End') to = n - 1;
        if (to === null) return;
        e.preventDefault();
        show(to, { user: true, focus: true, dir: dir });
      });
      /* Überfahren wählt (nur Maus, kurz verzögert gegen Flackern) */
      if (cfg.hover && fine.matches) {
        var tm = 0;
        t.addEventListener('pointerenter', function (e) {
          if (e.pointerType !== 'mouse') return;
          window.clearTimeout(tm);
          tm = window.setTimeout(function () { show(k, { user: true }); }, 90);
        });
        t.addEventListener('pointerleave', function () { window.clearTimeout(tm); });
      }
    });

    each(root.querySelectorAll('[data-ch-prev]'), function (b) { b.addEventListener('click', function () { show(cur - 1, { user: true, dir: -1 }); }); });
    each(root.querySelectorAll('[data-ch-next]'), function (b) { b.addEventListener('click', function () { show(cur + 1, { user: true, dir: 1 }); }); });

    /* Wischen (Touch): links = nächstes, rechts = voriges */
    if (cfg.swipeEl) {
      var x0 = 0, y0 = 0, t0 = 0, on = false;
      cfg.swipeEl.addEventListener('touchstart', function (e) {
        if (e.touches.length !== 1) { on = false; return; }
        x0 = e.touches[0].clientX; y0 = e.touches[0].clientY; t0 = Date.now(); on = true;
      }, { passive: true });
      cfg.swipeEl.addEventListener('touchend', function (e) {
        if (!on) return;
        on = false;
        var t = e.changedTouches[0];
        var dx = t.clientX - x0, dy = t.clientY - y0;
        if (Math.abs(dx) < 40 || Math.abs(dx) < Math.abs(dy) * 1.3 || Date.now() - t0 > 900) return;
        show(cur + (dx < 0 ? 1 : -1), { user: true, dir: dx < 0 ? 1 : -1 });
      }, { passive: true });
    }

    /* Selbst wechseln (nur mit Bewegung, nur sichtbar).
       Standard: einmal reihum, danach Ruhe; jede eigene Wahl beendet es.
       cfg.loop (Daniel und Shearling, 12.10.2026): läuft immer weiter. Pause, solange jemand die
       Maus darüber bewegt (ruht sie 2,5 s, geht es weiter) oder mit der Tastatur
       darin ist; nach eigener Wahl oder Antippen zwei Takte Pause.
       .is-tick läuft synchron zum Zeitgeber (Ring bei Daniel, Linie bei Shearling). */
    var ms = (parseFloat(root.getAttribute('data-auto')) || 0) * 1000;
    if (ms > 0 && n > 1 && motionOn() && hasIO) {
      var timer = 0, later = 0, vis = false, stopped = false, steps = 0;
      var over = false, moved = 0, keys = false, until = 0, IDLE = 2500;
      root.style.setProperty('--auto', ms + 'ms');
      var arm = function () {
        window.clearTimeout(timer);
        window.clearTimeout(later);
        root.classList.remove('is-tick');
        if (stopped || keys || !vis || document.hidden) return;
        var now = Date.now();
        var wait = Math.max(until - now, over ? moved + IDLE - now : 0);
        if (wait > 0) { later = window.setTimeout(arm, wait + 30); return; }
        void root.offsetWidth;
        root.classList.add('is-tick');
        timer = window.setTimeout(function () {
          show(cur + 1, { dir: 1 });
          steps += 1;
          if (!cfg.loop && steps >= n) { stopAuto(); return; }
          arm();
        }, ms);
      };
      if (cfg.loop) {
        stopAuto = function () { until = Date.now() + ms * 2; arm(); };
        root.addEventListener('focusin', function (e) {
          var kb = false;
          try { kb = e.target.matches(':focus-visible'); } catch (err) {}
          if (kb && !keys) { keys = true; arm(); }
        });
        root.addEventListener('focusout', function (e) {
          if (keys && !(e.relatedTarget && root.contains(e.relatedTarget))) { keys = false; arm(); }
        });
        (cfg.stopOn || []).forEach(function (el) {
          if (!el) return;
          el.addEventListener('pointerenter', function (e) { if (e.pointerType === 'mouse') over = true; });
          el.addEventListener('pointermove', function (e) {
            if (e.pointerType !== 'mouse') return;
            over = true;
            moved = Date.now();
            if (root.classList.contains('is-tick')) arm();      /* läuft gerade: anhalten */
          }, { passive: true });
          el.addEventListener('pointerleave', function (e) { if (e.pointerType === 'mouse') { over = false; arm(); } });
          el.addEventListener('touchstart', function () { until = Date.now() + ms * 2; arm(); }, { passive: true });
        });
      } else {
        stopAuto = function () { stopped = true; window.clearTimeout(timer); window.clearTimeout(later); root.classList.remove('is-tick'); };
        root.addEventListener('focusin', function () { stopAuto(); });
        (cfg.stopOn || []).forEach(function (el) {
          if (!el) return;
          el.addEventListener('pointerenter', function (e) { if (e.pointerType === 'mouse') stopAuto(); });
          el.addEventListener('touchstart', function () { stopAuto(); }, { passive: true });
        });
      }
      new IntersectionObserver(function (en) { vis = en[0].intersectionRatio >= 0.4; arm(); }, { threshold: [0, 0.4, 0.8] }).observe(root);
      document.addEventListener('visibilitychange', arm);
    }

    return { show: show, current: function () { return cur; }, count: n };
  }

  /* Einmal einblenden, sobald der Abschnitt ins Bild kommt */
  function enter(sec, threshold) {
    if (!motionOn() || !hasIO) { sec.classList.add('is-in'); return; }
    var io = new IntersectionObserver(function (en) {
      if (!en[0].isIntersecting) return;
      sec.classList.add('is-in');
      io.disconnect();
    }, { rootMargin: '0px 0px -8% 0px', threshold: threshold || 0.15 });
    io.observe(sec);
  }

  /* ── h5-variants v5: Finish-Wähler ──────────────────────────────────── */
  function finishes(sec) {
    if (!once(sec, 'h5v5')) return;
    var stage = sec.querySelector('.h5v__stage');
    var picker = sec.querySelector('.h5v__picker');
    var info = sec.querySelector('.h5v__info');
    chooser(sec, {
      hover: true, loop: true, swipeEl: stage, stopOn: [stage, picker, info],
      /* Steckbrief erst ansagen, wenn jemand selbst wählt (nicht bei jedem Selbst-Wechsel) */
      onUser: function () { if (info && info.getAttribute('aria-live') !== 'polite') info.setAttribute('aria-live', 'polite'); }
    });
    enter(sec, 0.18);
    if (fine.matches && motionOn()) follow(sec, sec, '--mx', '--my', 0.06);
    viewSwitch(sec);
  }

  /* Model | Produkt: Produktfotos erst beim ersten Umschalten laden.
     Gleiche Wahl wie in den Kategorien (localStorage tigha:view). */
  function viewSwitch(sec) {
    var box = sec.querySelector('.h5v__view');
    if (!box) return;
    var btns = box.querySelectorAll('[data-h5v-view]');
    function ready(im) {
      im.classList.add('is-ready');
      var l = im.closest('.h5v__layer');
      if (l) l.classList.add('has-p');
    }
    function loadPacks() {
      each(sec.querySelectorAll('.h5v__img--p'), function (im) {
        if (!im.getAttribute('data-h5-src')) return;
        im.addEventListener('load', function () { ready(im); }, { once: true });
        loadImg(im);
      });
    }
    function set(v, user) {
      v = v === 'product' ? 'product' : 'model';
      sec.setAttribute('data-view', v);
      each(btns, function (b) { b.setAttribute('aria-pressed', b.getAttribute('data-h5v-view') === v ? 'true' : 'false'); });
      if (v === 'product') loadPacks();
      if (user) { try { window.localStorage.setItem('tigha:view', v); } catch (err) {} }
    }
    each(btns, function (b) {
      b.addEventListener('click', function () { set(b.getAttribute('data-h5v-view'), true); });
    });
    /* mit der Maus schon beim Annähern vorladen, damit das Umschalten sofort sitzt;
       Überfahren des Bilds zeigt das zweite Foto (CSS), also auch dort laden */
    if (fine.matches) {
      box.addEventListener('pointerenter', loadPacks, { once: true });
      var fr = sec.querySelector('.h5v__frame');
      if (fr) fr.addEventListener('pointerenter', loadPacks, { once: true });
    }
    var pref = null;
    try { pref = window.localStorage.getItem('tigha:view'); } catch (err) {}
    set(pref === 'product' ? 'product' : 'model', false);
  }

  /* ── h5-basics: Basics für Herren und Damen nebeneinander ──────────────
     12.10.2026 (Chris: „Mayra als Basic für Frauen, beides nebeneinander“).
     Jede Seite ist ein eigener Wähler (Lederproben, Überfahren mit der Maus,
     Wischen über das Bild). Ohne Eingriff wechselt abwechselnd links und rechts
     die Farbe (data-auto Sekunden); der Ring um die Probe zeigt, wo es als
     Nächstes wechselt. Pause, solange die Maus darüber bewegt wird (ruht sie
     2,5 s, geht es weiter), mit der Tastatur darin und nach eigener Wahl zwei Takte.
     Zweites Foto (Freisteller) lädt beim ersten Überfahren des Bilds. */
  function basics(sec) {
    if (!once(sec, 'h5b')) return;
    var ms = (parseFloat(sec.getAttribute('data-auto')) || 0) * 1000;
    var sides = [];
    var timer = 0, later = 0, vis = false, over = false, moved = 0, keys = false, until = 0, turn = 0, IDLE = 2500;
    function packs(sd) {
      each(sd.querySelectorAll('img[data-h5p-src]'), function (im) {
        im.addEventListener('load', function () { im.classList.add('is-ready'); }, { once: true });
        loadImg(im, 'data-h5p-');
      });
    }
    function clearTick() { sides.forEach(function (x) { x.el.classList.remove('is-tick'); }); }
    function arm() {
      window.clearTimeout(timer);
      window.clearTimeout(later);
      clearTick();
      if (!(ms > 0) || !sides.length || keys || !vis || document.hidden) return;
      var now = Date.now();
      var wait = Math.max(until - now, over ? moved + IDLE - now : 0);
      if (wait > 0) { later = window.setTimeout(arm, wait + 30); return; }
      var x = sides[turn % sides.length];
      void x.el.offsetWidth;
      x.el.classList.add('is-tick');
      timer = window.setTimeout(function () {
        x.el.classList.remove('is-tick');
        x.ch.show(x.ch.current() + 1, { dir: 1 });
        turn += 1;
        arm();
      }, ms);
    }
    each(sec.querySelectorAll('[data-h5b-side]'), function (sd) {
      var frame = sd.querySelector('.h5b__frame');
      var ch = chooser(sd, {
        hover: true, swipeEl: frame,
        onUser: function () { until = Date.now() + ms * 2; arm(); }
      });
      if (ch && ch.count > 1) sides.push({ el: sd, ch: ch });
      if (fine.matches && frame) frame.addEventListener('pointerenter', function () { packs(sd); }, { once: true });
    });
    enter(sec, 0.15);
    if (!(ms > 0) || !sides.length || !motionOn() || !hasIO) return;
    sec.style.setProperty('--auto', ms + 'ms');
    sec.addEventListener('pointermove', function (e) {
      if (e.pointerType !== 'mouse') return;
      over = true;
      moved = Date.now();
      if (sec.querySelector('.h5b__side.is-tick')) arm();     /* läuft gerade: anhalten */
    }, { passive: true });
    sec.addEventListener('pointerleave', function (e) { if (e.pointerType === 'mouse') { over = false; arm(); } });
    sec.addEventListener('touchstart', function () { until = Date.now() + ms * 2; arm(); }, { passive: true });
    sec.addEventListener('focusin', function (e) {
      var kb = false;
      try { kb = e.target.matches(':focus-visible'); } catch (err) {}
      if (kb && !keys) { keys = true; arm(); }
    });
    sec.addEventListener('focusout', function (e) {
      if (keys && !(e.relatedTarget && sec.contains(e.relatedTarget))) { keys = false; arm(); }
    });
    new IntersectionObserver(function (en) { vis = en[0].intersectionRatio >= 0.35; arm(); }, { threshold: [0, 0.35, 0.7] }).observe(sec);
    document.addEventListener('visibilitychange', arm);
  }

  /* ── h5-sides: Herren und Damen ─────────────────────────────────────── */
  function sides(sec) {
    if (!once(sec, 'h5s')) return;
    each(sec.querySelectorAll('.h5s__side'), function (side) {
      var cache = {};
      items.push({ el: side, update: function (r, vh) {
        put(side, cache, '--h5e', easeOut(range((vh - r.top) / vh, 0.04, 0.42)));
        put(side, cache, '--q', clamp(((vh - r.top) / (vh + r.height)) * 2 - 1, -1, 1));
      } });
      if (fine.matches) follow(side, side, '--mx', '--my', 0.1);
    });
  }

  /* ── h5-pairs v5: Shearling-Wähler ──────────────────────────────────── */
  function shearling(sec) {
    if (!once(sec, 'h5p5')) return;
    var tabsEl = sec.querySelector('.h5p__tabs');
    var ink = sec.querySelector('.h5p__ink');
    var stage = sec.querySelector('.h5p__stage');
    var tabs = sec.querySelectorAll('[data-ch-tab]');
    var n = tabs.length;
    function warm(i) {
      if (!n) return;
      i = ((i % n) + n) % n;
      each(sec.querySelectorAll('[data-ch-panel="' + i + '"] img[data-h5-src]'), function (im) { loadImg(im); });
    }
    function moveInk(i, scroll) {
      var t = tabs[i];
      if (!t || !ink) return;
      ink.style.setProperty('--ix', t.offsetLeft + 'px');
      ink.style.setProperty('--iw', t.offsetWidth + 'px');
      if (scroll && tabsEl && tabsEl.scrollWidth > tabsEl.clientWidth + 2) {
        var to = t.offsetLeft - (tabsEl.clientWidth - t.offsetWidth) / 2;
        tabsEl.scrollTo({ left: Math.max(0, to), behavior: reduce.matches ? 'auto' : 'smooth' });
      }
    }
    var firstT = 0;
    /* Auftritt fertig: .is-anim mit entfernen, sonst greift danach die Tür-Animation
       des Wechsels und die Bilder schließen und öffnen sich ein zweites Mal */
    function clearFirst() {
      window.clearTimeout(firstT);
      each(sec.querySelectorAll('.h5p__panel.is-first'), function (p) { p.classList.remove('is-first', 'is-anim'); });
    }
    var ch = chooser(sec, {
      loop: true, swipeEl: stage,
      stopOn: [tabsEl, stage],
      onChange: function (i) { clearFirst(); moveInk(i, true); warm(i); warm(i + 1); }
    });
    if (!ch) return;
    var sync = function () { moveInk(ch.current(), false); };
    sync();
    /* erster Auftritt: Herren und Damen fliegen von außen ein (.is-first), Buchstaben steigen auf */
    if (motionOn() && hasIO && stage) {
      var io0 = new IntersectionObserver(function (en) {
        if (!en[0].isIntersecting) return;
        io0.disconnect();
        var p = sec.querySelector('.h5p__panel.is-on');
        if (p) {
          p.classList.remove('is-anim');
          void p.offsetWidth;
          p.classList.add('is-anim', 'is-first');
          firstT = window.setTimeout(clearFirst, 1800);
        }
        sec.classList.add('is-in');
      }, { rootMargin: '0px 0px -16% 0px', threshold: 0 });
      io0.observe(stage);
      /* Scrollen: Bilder gleiten gespiegelt, das große Wort wandert (--py −1 … 1) */
      var cache = {};
      items.push({ el: stage, update: function (r, vh) {
        put(stage, cache, '--py', clamp(((vh - r.top) / (vh + r.height)) * 2 - 1, -1, 1));
      } });
      /* Maus: Bilder folgen leicht */
      if (fine.matches) follow(stage, stage, '--mx', '--my', 0.07);
    } else {
      sec.classList.add('is-in');
    }
    window.addEventListener('resize', sync);
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(sync);
    /* nächstes Modell vorladen, sobald der Abschnitt näher kommt */
    if (hasIO) {
      var io = new IntersectionObserver(function (en) {
        if (!en[0].isIntersecting) return;
        warm(ch.current() + 1);
        io.disconnect();
      }, { rootMargin: '400px 0px' });
      io.observe(sec);
    } else { warm(1); }
  }

  /* Hover-Bild (Produktfoto) erst bei der ersten Berührung mit der Maus laden */
  function hoverImages(scope) {
    if (!fine.matches) return;
    each(scope.querySelectorAll('.h5p__card'), function (card) {
      var im = card.querySelector('[data-hover-src]');
      if (!im || !once(card, 'h5hover')) return;
      card.addEventListener('pointerenter', function () {
        if (!im.getAttribute('data-hover-src')) return;
        im.addEventListener('load', function () { im.classList.add('is-ready'); }, { once: true });
        loadImg(im, 'data-hover-');
      });
    });
  }

  /* ── Love Story: Rücken Herren / Damen umschalten ───────────────────── */
  function loveSwitch(scope) {
    each(scope.querySelectorAll('[data-ls]'), function (box) {
      if (!once(box, 'h5ls')) return;
      var sec = box.closest('.lovestory') || box.parentNode;
      var layers = box.querySelectorAll('[data-ls-layer]');
      var btns = box.querySelectorAll('.ls-switch [data-ls-to]');
      var cur = '0';
      function load(l) { var im = l.querySelector('img[data-ls-src]'); if (im) loadImg(im, 'data-ls-'); }
      function show(to) {
        to = String(to);
        if (to === cur) return;
        cur = to;
        each(layers, function (l) {
          var on = l.getAttribute('data-ls-layer') === to;
          if (on) load(l);
          l.classList.toggle('is-on', on);
        });
        each(btns, function (b) { b.setAttribute('aria-pressed', b.getAttribute('data-ls-to') === to ? 'true' : 'false'); });
      }
      each(btns, function (b) { b.addEventListener('click', function () { show(b.getAttribute('data-ls-to')); }); });
      if (fine.matches) {
        each(sec.querySelectorAll('.love-links [data-ls-to]'), function (a) {
          a.addEventListener('pointerenter', function () { show(a.getAttribute('data-ls-to')); });
          a.addEventListener('focus', function () { show(a.getAttribute('data-ls-to')); });
        });
      }
      if (hasIO) {
        var io = new IntersectionObserver(function (en) {
          if (!en[0].isIntersecting) return;
          each(layers, load);
          io.disconnect();
        }, { rootMargin: '300px 0px' });
        io.observe(box);
      } else { each(layers, load); }
    });
  }

  /* ── Journal: Bild des Artikels links neben der Liste, folgt der Maus in der Höhe ── */
  function journalPeek(scope) {
    if (!fine.matches) return;
    each(scope.querySelectorAll('[data-jn]'), function (list) {
      if (!once(list, 'h5jn')) return;
      var x = 0, y = 0, tx = 0, ty = 0, raf = 0;
      function loop() {
        x += (tx - x) * 0.2;
        y += (ty - y) * 0.2;
        list.style.setProperty('--jx', x.toFixed(1) + 'px');
        list.style.setProperty('--jy', y.toFixed(1) + 'px');
        raf = Math.abs(tx - x) > 0.3 || Math.abs(ty - y) > 0.3 ? window.requestAnimationFrame(loop) : 0;
      }
      function aim(e, jump) {
        var b = list.getBoundingClientRect();
        var th = list.querySelector('.jn-thumb');
        var w = th ? th.offsetWidth : 240, h = th ? th.offsetHeight : 300;
        /* waagerecht fest links neben der Liste (verdeckt keinen Text), senkrecht mit der Maus */
        tx = -(w + 36);
        ty = clamp(e.clientY - b.top - h / 2, -h * 0.25, b.height - h * 0.75);
        if (jump) { x = tx; y = ty; }
        if (!raf) raf = window.requestAnimationFrame(loop);
      }
      list.addEventListener('pointerenter', function (e) { if (e.pointerType === 'mouse') aim(e, true); });
      list.addEventListener('pointermove', function (e) { if (e.pointerType === 'mouse') aim(e, false); });
    });
  }

  /* ── Manifest: Wörter hellen beim Scrollen nacheinander auf ─────────── */
  function manifestWords(scope) {
    each(scope.querySelectorAll('.h5 .manifest blockquote'), function (q) {
      if (!once(q, 'h5mw')) return;
      var n = 0;
      (function walk(node) {
        each(Array.prototype.slice.call(node.childNodes), function (k) {
          if (k.nodeType === 3) {
            if (!k.textContent.trim()) return;
            var frag = document.createDocumentFragment();
            each(k.textContent.split(/(\s+)/), function (part) {
              if (!part) return;
              if (/^\s+$/.test(part)) { frag.appendChild(document.createTextNode(part)); return; }
              var w = document.createElement('span');
              w.className = 'mfw';
              w.style.setProperty('--i', n++);
              w.textContent = part;
              frag.appendChild(w);
            });
            node.replaceChild(frag, k);
          } else if (k.nodeType === 1 && !k.classList.contains('visually-hidden')) {
            walk(k);
          }
        });
      })(q);
      q.style.setProperty('--n', n);
      q.classList.add('mf-words');
      var cache = {};
      items.push({ el: q, update: function (r, vh) {
        put(q, cache, '--p', clamp((vh * 0.9 - r.top) / (vh * 0.55), 0, 1));
      } });
    });
  }

  /* ── Laufband: driftet und zieht beim Scrollen an ───────────────────── */
  function marquee(el) {
    if (!once(el, 'h5mq')) return;
    var track = el.firstElementChild;
    if (!track || !hasIO) return;
    var x = 0, last = 0, lastY = window.scrollY, v = 0, visible = false, raf = 0;
    function step(t) {
      var dt = last ? Math.min(64, t - last) : 16;
      last = t;
      var y = window.scrollY, dy = Math.abs(y - lastY);
      lastY = y;
      v += (dy * 0.4 - v) * 0.08;
      x -= (0.045 + v * 0.02) * dt;
      var half = track.scrollWidth / 2;
      if (half > 0 && -x > half) x += half;
      track.style.transform = 'translate3d(' + x.toFixed(1) + 'px,0,0)';
      raf = visible ? window.requestAnimationFrame(step) : 0;
    }
    new IntersectionObserver(function (en) {
      visible = en[0].isIntersecting;
      if (visible && !raf) { last = 0; raf = window.requestAnimationFrame(step); }
    }).observe(el);
  }

  /* ── h5-shelf: Regal mit Reitern ────────────────────────────────────── */
  /* Hier startet kein Ziehen und der Kreis „Ziehen“ weicht dem normalen Zeiger */
  var NOGRAB = 'button, input, select, label, [role="button"], [data-card-add], [data-card-sizes], [data-cdot], [data-quick-add], [data-quickadd], [data-quickview]';
  /* Ziehen mit der Maus samt Nachlauf. Wischen am Handy bleibt nativ. */
  function drag(t) {
    if (!fine.matches || !once(t, 'h5drag')) return;
    var down = false, moved = false, sx = 0, sl = 0, lx = 0, lt = 0, v = 0, raf = 0;
    each(t.querySelectorAll('img, a'), function (el) { el.setAttribute('draggable', 'false'); });
    t.addEventListener('pointerdown', function (e) {
      if (e.pointerType !== 'mouse' || e.button !== 0) return;
      moved = false;                                      /* ein altes „gezogen“ darf keinen neuen Klick schlucken */
      /* Größen, Farbpunkte und Knöpfe in der Karte bleiben klickbar */
      if (e.target.closest(NOGRAB)) return;
      down = true; sx = lx = e.clientX; sl = t.scrollLeft; lt = performance.now(); v = 0;
      window.cancelAnimationFrame(raf);
    });
    window.addEventListener('pointermove', function (e) {
      if (!down) return;
      var dx = e.clientX - sx;
      if (!moved) {
        if (Math.abs(dx) < 6) return;
        moved = true;
        t.classList.add('is-drag');
      }
      var now = performance.now();
      v = (e.clientX - lx) / Math.max(1, now - lt);
      lx = e.clientX; lt = now;
      t.scrollLeft = sl - dx;
    });
    function up() {
      if (!down) return;
      down = false;
      if (!moved) return;
      /* der Klick direkt nach dem Loslassen wird noch geschluckt, danach ist „gezogen“ vorbei
         (auch wenn die Maus außerhalb der Reihe losgelassen wurde und kein Klick kam) */
      window.setTimeout(function () { t.classList.remove('is-drag'); moved = false; }, 0);
      if (performance.now() - lt > 90) v = 0;            /* angehalten und losgelassen: kein Nachlauf */
      var vel = -v * 16;
      (function glide() {
        if (Math.abs(vel) < 0.4) return;
        t.scrollLeft += vel;
        vel *= 0.93;
        raf = window.requestAnimationFrame(glide);
      })();
    }
    window.addEventListener('pointerup', up);
    window.addEventListener('pointercancel', up);
    /* Nach dem Ziehen keinen Klick auf die Karte auslösen */
    t.addEventListener('click', function (e) {
      if (!moved) return;
      e.preventDefault();
      e.stopPropagation();
      moved = false;
    }, true);
  }

  /* Kreis „Ziehen“ folgt der Maus über der Reihe */
  function dragCursor(sec) {
    var cur = sec.querySelector('.h5r__cursor');
    var area = sec.querySelector('.h5r__panes');
    if (!cur || !area || !fine.matches) return;
    var x = 0, y = 0, tx = 0, ty = 0, raf = 0, on = false;
    function loop() {
      x += (tx - x) * 0.24;
      y += (ty - y) * 0.24;
      cur.style.transform = 'translate3d(' + x.toFixed(1) + 'px,' + y.toFixed(1) + 'px,0)';
      raf = Math.abs(tx - x) > 0.3 || Math.abs(ty - y) > 0.3 ? window.requestAnimationFrame(loop) : 0;
    }
    area.addEventListener('pointermove', function (e) {
      if (e.pointerType !== 'mouse') return;
      tx = e.clientX; ty = e.clientY;
      if (!on) { on = true; x = tx; y = ty; }
      /* über Knöpfen (Größen, Farben, Merken) den normalen Zeiger zeigen */
      sec.classList.toggle('is-cursor', !e.target.closest(NOGRAB));
      if (!raf) raf = window.requestAnimationFrame(loop);
    });
    area.addEventListener('pointerleave', function () { on = false; sec.classList.remove('is-cursor', 'is-press'); });
    area.addEventListener('pointerdown', function (e) { if (e.pointerType === 'mouse') sec.classList.add('is-press'); });
    window.addEventListener('pointerup', function () { sec.classList.remove('is-press'); });
    window.addEventListener('scroll', function () { if (on) { on = false; sec.classList.remove('is-cursor'); } }, { passive: true });
  }

  /* ── Regal festhalten: senkrechtes Scrollen schiebt die Reihe einmal durch ──
     12.10.2026 (Chris: „Biker soll beim Scrollen stoppen und einmal durch die Leiste scrollen“).
     Der Abschnitt wird so hoch wie Bildschirm + Weg der Reihe (--pin); innen klebt .h5r__pin oben.
     Seite → Reihe: Fortschritt der Strecke = Fortschritt der Reihe (scrollLeft).
     Reihe → Seite: Wischen, Ziehen, Pfeile und Tastatur verschieben die Seite passend mit,
     damit beides zusammenbleibt. Nur mit Bewegung, nicht im Theme-Editor, nur wenn Kleben geht. */
  var PIN_SPEED = 1;   /* senkrechte Pixel je Pixel Reihe (kurze Reihen) */
  var PIN_MAX = 2.4;   /* lange Reihen (ganze Kollektion): Strecke höchstens 2,4 Bildschirmhöhen, Reihe läuft dann schneller (höchstens gut doppelt so schnell) */
  function canStick(el) {
    try {
      if (!window.CSS || !CSS.supports('position', 'sticky') || !CSS.supports('overflow', 'clip')) return false;
    } catch (err) { return false; }
    for (var a = el.parentElement; a && a !== document.body && a !== html; a = a.parentElement) {
      var cs = window.getComputedStyle(a);
      if (/auto|scroll|hidden/.test(cs.overflowX + ' ' + cs.overflowY)) return false;
    }
    var vis = function (cs) { return cs.overflowX === 'visible' && cs.overflowY === 'visible'; };
    return vis(window.getComputedStyle(html)) || vis(window.getComputedStyle(document.body));
  }
  function jumpTo(y) {
    var sb = html.style.scrollBehavior;
    html.style.scrollBehavior = 'auto';
    window.scrollTo(0, Math.round(y));
    html.style.scrollBehavior = sb;
  }
  function pinRow(sec, track, sync) {
    var pin = sec.querySelector('[data-h5r-pin]');
    var panesEl = sec.querySelector('.h5r__panes');
    if (!pin || !panesEl || !motionOn() || !hasIO || (window.Shopify && window.Shopify.designMode) || !canStick(sec)) return null;
    var head = sec.querySelector('.h5r__head');
    var foot = sec.querySelector('.h5r__foot');
    var on = false, max = 0, lastX = 0, lastP = -1, userUntil = 0, mw = 0, mh = 0, rt = 0;

    function off() {
      on = false;
      html.classList.remove('h5-pin-on');
      sec.classList.remove('is-pin', 'has-cw');
      sec.style.removeProperty('--pin');
      sec.style.removeProperty('--cw');
    }
    function need() { return (head ? head.offsetHeight : 0) + panesEl.offsetHeight + (foot ? foot.offsetHeight : 0); }
    function measure(force) {
      var t = track();
      if (!t) { off(); return; }
      sec.classList.add('is-pin');
      var w = window.innerWidth, h = pin.clientHeight;
      if (!force && on && w === mw && h === mh) return;
      mw = w; mh = h;
      sec.classList.remove('has-cw');
      sec.style.removeProperty('--cw');
      var cs = window.getComputedStyle(pin);
      var room = h - parseFloat(cs.paddingTop) - parseFloat(cs.paddingBottom);
      /* passt nicht auf den Bildschirm: Karten schmaler (Bild und Text wachsen fast linear mit der Breite) */
      for (var k = 0; k < 4 && need() > room + 1; k++) {
        var item = t.querySelector('.h5r__item');
        if (!item) break;
        var iw = item.offsetWidth, ih = item.offsetHeight;
        var cw = Math.floor(iw * (ih - (need() - room)) / Math.max(1, ih));
        if (cw < 150) { off(); return; }
        sec.style.setProperty('--cw', cw + 'px');
        sec.classList.add('has-cw');
      }
      if (need() > room + 2) { off(); return; }
      max = Math.max(0, t.scrollWidth - t.clientWidth);
      if (max < 40) { off(); return; }
      sec.style.setProperty('--pin', Math.round(Math.min(max * PIN_SPEED, Math.max(h * PIN_MAX, max * 0.45))) + 'px');
      on = true;
      lastP = -1;
    }
    function progress(r) {
      var span = r.height - pin.offsetHeight;
      return span > 0 ? clamp(-r.top / span, 0, 1) : 0;
    }
    /* Seite → Reihe */
    items.push({ el: sec, update: function (r) {
      if (!on) return;
      var t = track();
      if (!t) return;
      var ph = pin.offsetHeight;
      /* Kleben klappt doch nicht (fremdes overflow o. Ä.): normale Reihe */
      if (r.top < -20 && r.bottom > ph + 20 && Math.abs(pin.getBoundingClientRect().top) > 3) { off(); return; }
      html.classList.toggle('h5-pin-on', r.top <= 0.5 && r.bottom >= ph - 0.5);
      var p = progress(r);
      if (p === lastP) return;
      lastP = p;
      if (Date.now() < userUntil) return;          /* jemand schiebt die Reihe gerade selbst */
      var x = Math.round(p * max);
      lastX = x;
      if (Math.abs(t.scrollLeft - x) > 0.5) t.scrollLeft = x;
    } });
    /* Reihe → Seite (Wischen, Ziehen, Pfeile, Tastatur) */
    function fromRow(e) {
      if (!on || e.currentTarget !== track()) return;
      var t = e.currentTarget, x = t.scrollLeft;
      if (Math.abs(x - lastX) <= 1.5) return;      /* selbst gesetzt */
      lastX = x;
      userUntil = Date.now() + 200;
      var r = sec.getBoundingClientRect();
      var ph = pin.offsetHeight;
      if (r.top > 1 || r.bottom < ph - 1) return;  /* nur solange der Abschnitt steht */
      var p = max > 0 ? clamp(x / max, 0, 1) : 0;
      lastP = p;
      jumpTo((window.pageYOffset || 0) + r.top + p * (r.height - ph));
    }
    each(panesEl.querySelectorAll('[data-h5r-track]'), function (t) { t.addEventListener('scroll', fromRow, { passive: true }); });

    function reset() {
      measure(true);
      var t = track();
      lastX = 0;
      if (t) t.scrollLeft = 0;
      if (!on) return;
      lastP = 0;
      var r = sec.getBoundingClientRect();
      if (r.top < 0) jumpTo((window.pageYOffset || 0) + r.top);
      sync();
      request();
    }
    window.addEventListener('resize', function () {
      window.clearTimeout(rt);
      rt = window.setTimeout(function () { measure(false); request(); }, 150);
    });
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(function () { measure(true); request(); });
    window.addEventListener('load', function () { measure(true); request(); });
    measure(true);
    request();
    return { reset: reset };
  }

  function shelf(sec) {
    if (!once(sec, 'h5r')) return;
    var tabs = sec.querySelectorAll('.h5r__tab');
    var panes = sec.querySelectorAll('[data-h5r-pane]');
    var bar = sec.querySelector('.h5r__bar');
    var prev = sec.querySelector('[data-h5r-prev]');
    var next = sec.querySelector('[data-h5r-next]');
    var all = sec.querySelector('[data-h5r-all]');
    var ink = sec.querySelector('.h5r__ink');
    var cur = 0;
    var pinned = null;
    each(panes, function (p, k) { if (!p.hidden && p.classList.contains('is-on')) cur = k; });

    function track() { var p = panes[cur]; return p ? p.querySelector('[data-h5r-track]') : null; }
    function sync() {
      var t = track();
      if (!t) return;
      var max = t.scrollWidth - t.clientWidth;
      if (bar) {
        bar.style.setProperty('--p', (max > 0 ? t.scrollLeft / max : 0).toFixed(4));
        bar.style.setProperty('--w', Math.min(1, t.clientWidth / Math.max(1, t.scrollWidth)).toFixed(4));
      }
      if (prev) prev.disabled = t.scrollLeft < 4;
      if (next) next.disabled = max <= 4 || t.scrollLeft > max - 4;
    }
    function moveInk() {
      if (!ink || !tabs[cur]) return;
      ink.style.setProperty('--ix', tabs[cur].offsetLeft + 'px');
      ink.style.setProperty('--iw', tabs[cur].offsetWidth + 'px');
      sec.classList.add('is-ready');
    }
    function replay(p) {
      if (!p || !html.classList.contains('h5m')) return;
      p.classList.remove('is-anim');
      void p.offsetWidth;
      p.classList.add('is-anim');
    }
    function show(i, focus) {
      if (i === cur || !panes[i]) return;
      each(tabs, function (b, k) {
        b.setAttribute('aria-selected', k === i ? 'true' : 'false');
        b.tabIndex = k === i ? 0 : -1;
      });
      each(panes, function (p, k) { p.hidden = k !== i; p.classList.toggle('is-on', k === i); });
      cur = i;
      var t = track();
      if (t) t.scrollLeft = 0;
      if (all && tabs[i] && tabs[i].getAttribute('data-url')) all.setAttribute('href', tabs[i].getAttribute('data-url'));
      replay(panes[i]);
      moveInk();
      sync();
      if (pinned) pinned.reset();
      if (focus) tabs[i].focus();
    }
    each(tabs, function (b, k) {
      b.addEventListener('click', function () { show(k); });
      b.addEventListener('keydown', function (e) {
        var n = tabs.length, to = -1;
        if (e.key === 'ArrowRight') to = (k + 1) % n;
        else if (e.key === 'ArrowLeft') to = (k - 1 + n) % n;
        else if (e.key === 'Home') to = 0;
        else if (e.key === 'End') to = n - 1;
        if (to < 0) return;
        e.preventDefault();
        show(to, true);
      });
    });
    function step(dir) {
      var t = track();
      if (!t) return;
      var item = t.querySelector('.h5r__item');
      var gap = parseFloat(window.getComputedStyle(t).columnGap) || 16;
      var w = item ? item.offsetWidth + gap : t.clientWidth * 0.8;
      var n = Math.max(1, Math.floor(t.clientWidth / w) - 1);
      t.scrollBy({ left: dir * n * w, behavior: reduce.matches ? 'auto' : 'smooth' });
    }
    if (prev) prev.addEventListener('click', function () { step(-1); });
    if (next) next.addEventListener('click', function () { step(1); });
    each(panes, function (p) {
      var t = p.querySelector('[data-h5r-track]');
      if (!t) return;
      t.addEventListener('scroll', sync, { passive: true });
      drag(t);
    });
    window.addEventListener('resize', function () { moveInk(); sync(); });
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(moveInk);
    dragCursor(sec);
    moveInk();
    sync();
    if (sec.hasAttribute('data-h5r-pinned')) pinned = pinRow(sec, track, sync);

    /* Einfahren beim Hereinscrollen (nur mit Bewegung) */
    if (!motionOn()) { sec.classList.add('is-in'); return; }
    var cache = {};
    items.push({ el: sec, update: function (r, vh) {
      var e = easeOut(range((vh - r.top) / vh, 0.02, 0.45));
      put(sec, cache, '--h5e', e);
      if (e > 0.1 && !sec.classList.contains('is-in')) {
        sec.classList.add('is-in');
        replay(panes[cur]);
      }
    } });
  }

  /* ── Start ──────────────────────────────────────────────────────────── */
  function init(scope) {
    scope = scope || document;
    if (motionOn()) html.classList.add('h5m');
    hoverImages(scope);
    each(scope.querySelectorAll('[data-h5r]'), shelf);
    each(scope.querySelectorAll('[data-h5v]'), finishes);
    each(scope.querySelectorAll('[data-h5b]'), basics);
    each(scope.querySelectorAll('[data-h5p]'), shearling);
    loveSwitch(scope);
    journalPeek(scope);
    if (!motionOn()) { html.classList.remove('h5m'); return; }
    html.classList.add('h5m');
    each(scope.querySelectorAll('.h5 .display.rv, .h5 [data-split]'), split);
    revealEarly(scope);
    rails(scope);
    hero(scope);
    if (scope === document) headerAway();
    each(scope.querySelectorAll('[data-h5s]'), sides);
    each(scope.querySelectorAll('[data-marquee]'), marquee);
    manifestWords(scope);
    request();
  }

  window.tighaMotion = init;
  window.tighaMotion.refresh = request;

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(document); });
  } else {
    init(document);
  }
  window.addEventListener('scroll', request, { passive: true });
  window.addEventListener('resize', request);
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
  /* Theme-Editor: gewählten Block (Finish/Modell) zeigen */
  document.addEventListener('shopify:block:select', function (e) {
    var t = e.target;
    if (t && t.hasAttribute && t.hasAttribute('data-ch-tab')) t.click();
  });
})();
